module.exports = __webpack_public_path__ + "images/award.png?v=43d7d9cfc56547dfccaa5e0e2da3955d";